import { useEffect, useState } from "react";
import styled from "styled-components";
import { useLocalization } from "../hooks/useLocalization";
import { Close } from "./Icons";

const BANNER_DISMISSED_KEY = "shortcut-banner-dismissed";

const BannerWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: rgba(20, 25, 40, 0.8);
  backdrop-filter: blur(10px);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 6px 16px;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.2);

  /* 針對平板尺寸 */
  @media (min-width: 768px) {
    padding: 8px 24px;
  }
`;

const Content = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  max-width: 1024px;
`;

const PromptText = styled.p`
  margin: 0;
  font-family: "PingFang TC", sans-serif;
  font-size: 12px;
  font-weight: 400;
  color: #e0e0e0;
  letter-spacing: 0.5px;
  flex-grow: 1;

  @media (min-width: 768px) {
    font-size: 14px;
  }
`;

const InstallButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px 16px;
  background: linear-gradient(360deg, #0c34f8 0%, #90b3ff 100%);
  color: white;
  border: none;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  text-decoration: none;
  cursor: pointer;
  transition: filter 0.2s;
  flex-shrink: 0;

  &:hover {
    filter: brightness(1.1);
  }

  @media (min-width: 768px) {
    font-size: 14px;
    padding: 6px 14px;
  }
`;

const CloseButton = styled.button`
  background: transparent;
  border: none;
  color: #888;
  cursor: pointer;
  padding: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  svg {
    width: 20px;
    height: 20px;
  }

  &:hover {
    color: #fff;
  }

  @media (min-width: 768px) {
    svg {
      width: 24px;
      height: 24px;
    }
  }
`;

export default function InstallShortcutBanner() {
  const [isVisible, setIsVisible] = useState(false);
  const { t } = useLocalization();

  useEffect(() => {
    const isIOS = /iPad|iPhone|iPod|Macintosh/.test(navigator.userAgent);
    const isDismissed = localStorage.getItem(BANNER_DISMISSED_KEY) === "true";

    if (isIOS && !isDismissed) {
      setIsVisible(true);
    }
  }, []);

  const handleDismiss = () => {
    localStorage.setItem(BANNER_DISMISSED_KEY, "true");
    setIsVisible(false);
  };

  const handleInstall = () => {
    window.open(
      "https://www.icloud.com/shortcuts/3f9f9bc183f843d1911d3223e76d8972",
      "_blank"
    );
    handleDismiss();
  };

  if (!isVisible) {
    return null;
  }

  return (
    <BannerWrapper>
      <Content>
        <PromptText>{t("install_shortcut_prompt")}</PromptText>
        <InstallButton onClick={handleInstall}>{t("install")}</InstallButton>
        <CloseButton onClick={handleDismiss}>
          <Close />
        </CloseButton>
      </Content>
    </BannerWrapper>
  );
}
